import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IncidentChart from './incidentChart';
import MultiLineChart from './multilinegraph';
import { blackdownload, downarrow } from '../utils/safetysvgs/safetysvg';

const Trends = () => {
  const option = ["Incidents", "Per 10k Hours"];
  const [selectedIncidentsOption, setSelectedIncidentsOption] = useState("Incidents");

  return (
    <div className="flex gap-4 w-full flex-wrap">
      {/* Left Card */}
      <div className="flex-1 rounded-[12.75px] border border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm min-w-[300px]">
        <div className="flex justify-between items-center flex-wrap gap-2">
          <div className="flex w-full justify-between items-start">
            <div>
              <h2 className="text-base font-semibold text-start text-[#0A0A0A]">Safety Trends</h2>
              <p className="text-sm font-normal text-[#717182]">12-month safety performance trends</p>
            </div>
            <div className="flex items-center gap-1 rounded-[6.75px] border border-[rgba(0,0,0,0.10)] bg-[#FFF] px-4 py-1 text-sm text-[#0A0A0A] hover:shadow-sm cursor-pointer">
              <span>Last 12 Months</span>
         {downarrow}
            </div>
          </div>
        </div>
        <div className='mt-8'>
        <MultiLineChart/>  
        </div>

      </div>

      {/* Right Card */}
      <div className="flex-1 rounded-[12.75px] border border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm min-w-[300px]">
        <div className="flex justify-between items-center flex-wrap gap-2">
          <div className="flex w-full justify-between items-start">
     <div>
      <h2 className="text-base font-normal text-start text-[#0A0A0A]">Facility Comparison</h2>
      <p className="text-sm font-normal text-[#717182]">Incidents by location with manhour data</p>
    </div>
            <div className="flex items-center gap-1 rounded-[6.75px] border border-[rgba(0,0,0,0.10)] bg-[#FFF] px-4 py-1 text-sm text-[#0A0A0A] hover:shadow-sm cursor-pointer">
     {blackdownload}
              <span>Export</span>
            </div>
          </div>
        </div>

        {/* Switch Buttons */}
    <div className="flex w-max rounded-[12.75px] bg-[#DBEAFE] p-1 mt-4">
  {option.map((label) => {
    const isSelected = selectedIncidentsOption === label;
    return (
      <button
        key={label}
        onClick={() => setSelectedIncidentsOption(label)}
        className={`px-3 py-1 text-sm font-medium rounded-[12.75px] transition-colors duration-200 ${
          isSelected ? "bg-white text-[#0A0A0A]" : "bg-transparent text-[#0A0A0A]"
        }`}
      >
        {label}
      </button>
    );
  })}
</div>

        <div className='mt-4'>
           <IncidentChart />
        </div>

        {/* Chart */}
       
      </div>
    </div>
  );
};

export default Trends;
